import React, { useEffect, useRef, useState } from "react";
import cssClasses from "./FastBooking.module.css";
import "../../App.css";
import DropDown from "../../Subcomponents/DropDown";
import { Card, FormControl, InputLabel, MenuItem, Select } from "@mui/material";
import { useDispatch } from "react-redux";
import action from "../../Redux Store/actions";
import { makeStyles } from "@mui/styles";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import checked from "../../Assets/Images/Common/checked.svg";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import ProjectView from "../../Assets/Images/Project images/Frame 48095724.svg";
import FloorPlanView from "../../Assets/Images/Project images/Frame 48095726.svg";

import { DataGrid } from "@mui/x-data-grid";
import SearchBar from "../../Subcomponents/Search";
import {
  getAllSalesByProjectFloorsUser,
  getAllSalesByProjectWingsUser,
  getAllUnitsByProjectId,
  getAllUnitsByProjectIdWings,
  getAllUnitsByWingId,
  getAllWingsByProjectId,
  getAssignedProjects,
  getWingsByProjectId,
} from '../../Services/SustenanceService';
import {
  getActiveLaunchInventory,
  getAllLaunchesByProject,
  getAllProjects,
  getAllUnitsByWingIdWithMerged,
  getAllUnitsFromLaunches,
  getEventInfo,
  getFutureLaunchInventory,
  getLaunches,
  getProjectPricing,
  getProjectsFromRpc,
  getSustenanceLaunchInventory,
  getSustenanceProject,
  getSustenanceProjectInventory,
  getWingsByLaunchIdFromRpc,
} from "../../Services/FastBooking";
import { debounce, intersection, sortBy, uniqBy } from "lodash";
import {
  getEvent,
  getEventLaunch,
  getEventLaunchAssignToken,
} from "../../Services/Event";
import Button from "../../Subcomponents/Button";
import { useNavigate } from "react-router-dom";
import { dismissLoader, presentLoader } from "../../Services/loader";
import { getAllEvents } from "../../Services/AssignNewToken";
import { supabase } from "../../supabaseClient";
import { useSelector } from "react-redux";

const useStyles = makeStyles((theme) => ({
  label: {
    fontFamily: "Inter-Regular !important",
    fontSize: "1.6rem !important",
    lineHeight: "2.4rem !important",
    color: "#98A2B3 !important",
    background: "#F2F4F7 !important",
    fontWeight: "400 !important",
    padding: "0px !important",
    "&.Mui-focused": {
      display: "none !important",
      color: " #84CAFF !important",
    },
    top: "50% !important",
    transform: "translate(10%, -50%) scale(1) !important",
  },
  helperText: {
    fontSize: "1.4rem !important",
    margin: "0.2rem 0 0 0 !important",
    color: "#d32f2f !important",
    textAlign: "left !important",
    fontFamily: "Inter-Medium !important",
  },
  form: {
    margin: "0rem !important",
  },
  select: {
    fontFamily: "Inter-Regular !important",
    fontSize: "1.6rem !important",
    border: "1px solid #EFF8FF !important",
    lineHeight: "2.4rem !important",
    background: "#F2F4F7 !important",
    color: "#98A2B3 !important",
    textAlign: "left",
    fontWeight: "400 !important",
    //  border: "1px solid #D0D5DD !important",
    borderRadius: "0.8rem !important",
    boxShadow: "0px 1px 2px rgba(16, 24, 40, 0.05)",
    "&.Mui-focused": {
      border: "1px solid #84CAFF !important",
      boxShadow:
        "0px 1px 2px rgba(16, 24, 40, 0.05), 0px 0px 0px 4px #D1E9FF  !important",
      background: "#FFFFFF !important",
    },
    "& .MuiSelect-outlined": {},
    "& fieldSet": {
      border: "none",
    },
    "& .MuiSelect-icon": {
      width: "2em !important",
      height: "2em !important",
      top: "0.5rem !important",
    },
    "&.Mui-error": {
      border: "1px solid red !important",
    },
    "& .MuiSelect-select": {
      padding: "0.8rem 1.4rem !important",
    },
  },
  wrapperli: {
    display: "flex",
    flexDirection: "row",
    width: "100%",
    justifyContent: "space-between",
  },
  labelTitle: {
    fontFamily: "Inter-Medium",
    fontSize: "1.4rem",
    lineHeight: "2rem",
    letterSpacing: "0.3px",
    color: "#344054",
    marginBottom: "0.6rem",
  },
}));
const MenuProps = {
  PaperProps: {
    style: {
      // width: 250,
      // overflowX: "auto",.
      "& .MuiSelected": {
        color: "#F9FAFB !important",
      },
    },
  },
};

const FastBooking = () => {
  const classes = useStyles();
  const navigate = useNavigate();
  const [unitMode, setUnitMode] = useState(null);
  let [allProjects, setAllProjects] = useState([]);
  const [selectedProjectData, setSelectedProjectData] = useState([]);
  //     { label: "Project 1", value: "Project 1", isSelected: false },
  const [selectedProject, setSelectedProject] = useState("");
  const [selectedProjectName, setSelectedProjectName] = useState("");
  let [allWings, setAllWings] = useState([]);

  const [selectedWing, setSelectedWing] = useState("");
  const [selectedWingName, setSelectedWingName] = useState("");
  let [allUnits, setAllUnit] = useState([]);
  let [selectedUnit, setSelectedUnit] = useState(null);
  const [selectedUnitId, setSelectedUnitId] = useState(null);
  // ?This is card
  let [searchResult, setSearchResults] = useState([]);
  const [showSearchResult, setShowSearchResult] = useState(false);
  const [type, setType] = useState("");
  const [eventList, setEventList] = useState([]);
  const [selectedEvent, setSelectedEvent] = useState("");
  const [selectedFloor, setSelectedFloor] = useState("");
  const [search, setSearch] = useState(null);
  const [allLaunches, setAllLaunches] = useState([]);
  const [selectedLaunch, setSelectedLaunch] = useState("");
  const [allLaunchesArray, setAllLaunchesArray] = useState([]);
  const dispatch = useDispatch();
  const loggedInUser = useSelector((state) => state.Auth.user);
  const SaleUserId = useRef("");
  useEffect(() => {
    SaleUserId.current = loggedInUser.userId;
    dispatch(action.activeMenu('fastbooking'));
    //What about sustenance project? or launchId===null or multiple launches with same projects

    // console.log('selectedProject: ', selectedProject);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  // ??Session storage get
  useEffect(() => {
    let type = JSON.parse(sessionStorage.getItem("fastBookingType")) ?? "";
    setType(JSON.parse(sessionStorage.getItem("fastBookingType")) ?? "");
    setSelectedEvent(
      JSON.parse(sessionStorage.getItem("fastBookingEvent")) ?? ""
    );
    let projectId =
      JSON.parse(sessionStorage.getItem("fastBookingSelectedProject")) ?? "";
    setSelectedProject(projectId);
    // ??Sustenance Project
    if (type === "Sustenance") {
      let projectIdSus =
        JSON.parse(sessionStorage.getItem("fastBookingSustenanceProject")) ??
        [];
      setAllProjects(projectIdSus);

      let wingId =
        JSON.parse(sessionStorage.getItem("fastBookingSelectedWing")) ?? "";
      setSelectedWing(
        JSON.parse(sessionStorage.getItem("fastBookingSelectedWing")) ?? ""
      );
      setAllWings(
        JSON.parse(sessionStorage.getItem("fastBookingAllWings")) ?? []
      );
      setSelectedWingName(
        JSON.parse(sessionStorage.getItem("fastBookingWingName")) ?? ""
      );
      console.log({ projectId }, { wingId });

      if (projectId !== "" && wingId !== "") {
        getAllUnits(projectId, wingId, selectedProjectData, null, "Sustenance");
      }
    } else if (type === "Event") {
      setEventList(
        JSON.parse(sessionStorage.getItem("fastBookingAllEvents")) ?? []
      );
      setAllLaunches(
        JSON.parse(sessionStorage.getItem("fastBookingAllLaunches")) ?? []
      );
      setSelectedLaunch(
        JSON.parse(sessionStorage.getItem("fastBookingSelectedLaunch")) ?? ""
      );
      setSelectedWingName(
        JSON.parse(sessionStorage.getItem("fastBookingWingName")) ?? ""
      );
      setSelectedWing(
        JSON.parse(sessionStorage.getItem("fastBookingSelectedWing")) ?? ""
      );
      setAllWings(
        JSON.parse(sessionStorage.getItem("fastBookingAllWings")) ?? []
      );
      getAllUnitsFun(
        JSON.parse(sessionStorage.getItem("fastBookingSelectedLaunch")),
        true,
        JSON.parse(sessionStorage.getItem("fastBookingSelectedWing")) ?? ""
      );
      // setAllUnit(JSON.parse(sessionStorage.getItem("fastBookingAllUnits")) ?? [])
    }
  }, []);

  // ??SnapShot call
  useEffect(() => {
    // let selectedUnit =
    //   JSON.parse(sessionStorage.getItem("fastBookingSelectedUnit")) ?? "";
    if (JSON.parse(sessionStorage.getItem("fastBookingSelectedProject"))) {
      let updateUnitListener = supabase
        .from(
          `Inventory:projectId=eq.${JSON.parse(
            sessionStorage.getItem("fastBookingSelectedProject")
          )}`
        )
        .on('UPDATE', (handleRecordUpdated) => {
          // console.log(handleRecordUpdated);
          if (handleRecordUpdated.eventType === 'UPDATE') {
            document.getElementById(
              "input-with-icon-textfield UnitSearch"
            ).value = "";
            if (
              JSON.parse(sessionStorage.getItem("fastBookingType")) === "Event"
            ) {
              getAllUnitsFun(
                JSON.parse(sessionStorage.getItem("fastBookingSelectedLaunch")),
                true,
                JSON.parse(sessionStorage.getItem("fastBookingSelectedWing")) ??
                ""
              );
            } else {
              let projectId =
                JSON.parse(
                  sessionStorage.getItem("fastBookingSelectedProject")
                ) ?? "";
              setSelectedProject(projectId);
              let wingId =
                JSON.parse(sessionStorage.getItem("fastBookingSelectedWing")) ??
                "";
              if (projectId !== "" && wingId !== "") {
                getAllUnits(
                  projectId,
                  wingId,
                  selectedProjectData,
                  null,
                  "Sustenance"
                );
              }
            }
          }
        })
        .subscribe((status) => {
          console.log("status: ", status);
        });
      return () => {
        if (updateUnitListener) {
          supabase.removeSubscription(updateUnitListener);
          updateUnitListener = null;
        }
      };
    }
  }, [JSON.parse(sessionStorage.getItem("fastBookingSelectedProject"))]);

  // ??Clear Session Storage
  function clearData() {
    sessionStorage.clear();
    setAllUnit([]);
    setAllLaunches([]);
    setAllWings([]);
    setSelectedLaunch("");
    setSelectedUnit(null);
    setSelectedUnitId("");
    setSelectedWing("");
    setSelectedProject("");
    setSelectedEvent("");
  }
  // ??For Sustenance
  function getProject() {
    // ! if loggedInUser is superadmin; show all projects
    if (loggedInUser.roleId.level === 1) {
      getAllProjects()
        .then((resp) => {
          // console.log(resp);
          resp.data = resp.data.map((each) => ({
            ...each,
            label: each.projectName,
            // label: each.projectname,
            value: each.projectId,
            // value: each.projectid,
            isSelected: false,
          }));
          setAllProjects([...resp.data]);
          sessionStorage.setItem(
            "fastBookingSustenanceProject",
            JSON.stringify([...resp.data])
          );
        })
        .catch((err) => {
          console.log(err);
        });
    } else {
      // ! if loggedInUser is not superadmin; show assigned projects
      getAssignedProjects(null, null, null, null, loggedInUser.userId, true)
        .then((resp) => {
          console.log(resp);
          // resp.data = resp.data.map((each) => ({
          //   ...each,
          //   label: each.projectName,
          //   // label: each.projectname,
          //   value: each.projectId,
          //   // value: each.projectid,
          //   isSelected: false,
          // }));
          let projects = [];
          projects = resp.data.map((proj) => ({
            ...proj.projectId,
            label: proj.projectId.projectName,
            value: proj.projectId.projectId,
            isSelected: false,
          }));
          setAllProjects([...projects]);
          sessionStorage.setItem(
            "fastBookingSustenanceProject",
            JSON.stringify([...projects])
          );
        })
        .catch((err) => {
          console.log(err);
        });
    }
  }
  // ??For getting events
  function getAllEventsFun() {
    getEventLaunchAssignToken(loggedInUser.userId, loggedInUser).then(
      (launchSalesRelationRes) => {
        dismissLoader();
        console.log({ launchSalesRelationRes });
        let eventArr = [];
        launchSalesRelationRes.data.forEach((el) => {
          eventArr.push(el.launchId.eventId);
        });
        let newArr = [];
        // resp.data=resp.data.filter(({allowTokenBuyingInEvent})=>allowTokenBuyingInEvent===true)
        uniqBy(eventArr, "eventId").forEach((el) => {
          // ??live event
          if (
            el.startDateTime < Date.now() &&
            el.endDateTime > Date.now() &&
            el.isPublished
          ) {
            newArr.push(el);
          }
        });
        // setEventList([...newArr]);
        newArr = newArr.map((each) => ({
          ...each,
          label: each.title,
          value: each.eventId,
        }));
        setEventList([...newArr]);
        sessionStorage.setItem(
          "fastBookingAllEvents",
          JSON.stringify([...newArr])
        );
        if (newArr.length === 1) {
          setSelectedEvent(newArr[0].eventId);
          sessionStorage.setItem(
            "fastBookingEvent",
            JSON.stringify(newArr[0].eventId)
          );
          getAllLaunches(newArr[0].eventId);
        }
      }
    );
    // getAllEvents()
    //   .then((resp) => {
    //     console.log(resp);
    //     resp.data = resp.data.map((each) => ({
    //       ...each,
    //       label: each.title,
    //       value: each.eventId,
    //     }))
    //     setEventList([...resp.data]);
    //     sessionStorage.setItem(
    //       "fastBookingAllEvents",
    //       JSON.stringify([...resp.data])
    //     );
    //     if (resp.data.length === 1) {
    //       setSelectedEvent(resp.data[0].eventId);
    //       sessionStorage.setItem(
    //         "fastBookingEvent",
    //         JSON.stringify(resp.data[0].eventId)
    //       );
    //       getAllLaunches(resp.data[0].eventId);
    //     }
    //   })
    //   .catch((err) => {
    //     console.log(err);
    //   });
  }

  // **get projects from launches
  function getAllLaunches(eventId) {
    getLaunches(eventId)
      .then((resp) => {
        console.log(resp);
        resp.data = resp.data.map((each) => ({
          ...each,
          label: each.title,
          value: each.launchId,
        }));
        setAllLaunches([...resp.data]);

        sessionStorage.setItem(
          "fastBookingAllLaunches",
          JSON.stringify([...resp.data])
        );
        // ??if one Launch is present only set it as default
        if (resp.data.length === 1) {
          setAllUnit([]);
          setSelectedWing("");
          setSelectedLaunch(resp.data[0].value);
          setSelectedProjectData(resp?.data[0].projectId);
          sessionStorage.setItem(
            "fastBookingSelectedLaunch",
            JSON.stringify(resp.data[0].value)
          );
          getWingsByLaunchId(resp.data[0].value);

          console.log("projectId", resp.data[0].projectId.projectId);
          setSelectedProject(resp.data[0].projectId.projectId);
          sessionStorage.setItem(
            "fastBookingSelectedProject",
            JSON.stringify(resp.data[0].projectId.projectId)
          );
        }
      })
      .catch((err) => {
        console.log(err);
      });
  }
  // ??Get All Wings and Units (Type==='Event')
  function getAllUnitsFun(launchId, refresh, selectedWing) {
    getAllUnitsFromLaunches(launchId, selectedWing)
      .then((resp) => {
        let UnitIdNotNull = resp.data.filter(({ unitId }) => unitId !== null);
        // console.log("unitIdNotNull", UnitIdNotNull);
        UnitIdNotNull = UnitIdNotNull.map((each) => ({
          ...each,
          label: each.unitId.wingId.wingName,
          value: each.unitId.wingId.wingId,
          inventoryTypeId: each.unitId.inventoryTypeId.inventoryTypeId,
        }));
        //  let InventoryTypeNotNull= resp.data.filter(({inventoryTypeId})=>inventoryTypeId!==null);
        let count = 0;
        presentLoader();
        if (UnitIdNotNull.length > 0) {
          UnitIdNotNull.forEach((units) => {
            getProjectPricing(
              units.launchId.projectId,
              units.wingId,
              units.unitId.inventoryTypeId.inventoryTypeId
            ).then((eachProjectPrice) => {
              count = count + 1;
              let projectPrice = null;
              // ** Check for StartDateTime and endDateTime is in Between today's date
              // **if true show Total else StartDateTime===null && endDateTime===null
              if (
                eachProjectPrice?.data[0]?.startDateTime < Date.now() &&
                eachProjectPrice?.data[0]?.endDateTime > Date.now()
              ) {
                projectPrice = numDifferentiation(
                  eachProjectPrice?.data[0]?.Total
                );
              }
              // else if (
              //   eachProjectPrice.data[0].startDateTime === null &&
              //   eachProjectPrice.data[0].endDateTime === null
              // ) {
              //   projectPrice = numDifferentiation(eachProjectPrice?.data[0].Total);
              // }
              else {
                projectPrice = numDifferentiation(
                  eachProjectPrice?.data[0]?.Total
                );
              }
              UnitIdNotNull = UnitIdNotNull.map((each) => ({
                ...each,
                floorNo:
                  each?.unitId.inventoryMergeId !== null
                    ? each?.unitId.inventoryMergeId.unit1Id.floorNo +
                    "-" +
                    each?.unitId.inventoryMergeId?.unit2Id.floorNo
                    : each.unitId.floorNo,
                mergedFloorNo:
                  each?.unitId.inventoryMergeId !== null
                    ? each?.unitId.inventoryMergeId.unit1Id.floorNo <
                      each?.unitId.inventoryMergeId?.unit2Id.floorNo
                      ? each?.unitId.inventoryMergeId.unit1Id.floorNo
                      : each?.unitId.inventoryMergeId?.unit2Id.floorNo
                    : each.unitId.floorNo,
                type:
                  each?.unitId.inventoryMergeId !== null
                    ? each?.unitId.inventoryMergeId.unit1Id.inventoryTypeId
                      .type +
                    "-" +
                    each?.unitId.inventoryMergeId?.unit2Id.inventoryTypeId
                      .type
                    : each.unitId.inventoryTypeId.type,
                displayUnitType: each?.unitId?.displayUnitType ?? "",
                mergedUnits:
                  each?.unitId.inventoryMergeId !== null
                    ? each?.unitId.inventoryMergeId.unit1No.toString() +
                    "-" +
                    each.unitId.inventoryMergeId.unit2No.toString()
                    : each?.unitId.unitNo.toString(),
                id: each.unitId.unitId,
                projectPrice: projectPrice,
                showUnitPrice: each?.launchId?.eventId?.showUnitPrice,
                showUnitDateTimePrice:
                  each?.launchId?.eventId?.showUnitPriceDateTime,
              }));

              // ??when we get all projectPricing
              if (count === UnitIdNotNull.length) {
                dismissLoader();
                // ??if wing is Only one set it as default
                // console.log(uniqBy([...UnitIdNotNull], "wingId"));

                sessionStorage.setItem(
                  "fastBookingAllLaunchesArray",
                  JSON.stringify([...UnitIdNotNull])
                );

                setAllLaunchesArray([...UnitIdNotNull]);
                if (refresh) {
                  sessionStorage.setItem(
                    "fastBookingAllUnits",
                    JSON.stringify(
                      uniqBy(
                        sortBy(
                          sortBy(UnitIdNotNull, "mergedUnits"),
                          "mergedFloorNo"
                        ),
                        "mergedUnits"
                      )
                    )
                  );
                  setAllUnit(
                    uniqBy(
                      sortBy(
                        sortBy(UnitIdNotNull, "mergedUnits"),
                        "mergedFloorNo"
                      ),
                      "mergedUnits"
                    )
                  );
                } else {
                  setAllUnit(
                    uniqBy(
                      sortBy(
                        sortBy(UnitIdNotNull, "mergedUnits"),
                        "mergedFloorNo"
                      ),
                      "mergedUnits"
                    )
                  );
                  sessionStorage.setItem(
                    "fastBookingAllUnits",
                    JSON.stringify(
                      uniqBy(
                        sortBy(
                          sortBy(UnitIdNotNull, "mergedUnits"),
                          "mergedFloorNo"
                        ),
                        "mergedUnits"
                      )
                    )
                  );
                }
              }
            });
          });
        } else {
          dismissLoader();
        }
      })
      .catch((err) => {
        dismissLoader();
        console.log(err);
      });
  }
  function getWingsByLaunchId(selectedLaunchId) {
    getWingsByLaunchIdFromRpc(selectedLaunchId)
      .then((allWings) => {
        console.log({ allWings });
        // ??When getting value fromrpc =>values are wingname,wingid
        allWings.data = allWings.data.map((each) => ({
          ...each,
          label: each.displaywingname ? each.displaywingname : each.wingname,
          value: each.wingid,
          wingId: each.wingid,
          wingName: each.wingname,
        }));
        if (allWings.data.length === 1) {
          setSelectedWing(allWings.data[0].wingid);
          setSelectedWingName(allWings.data[0].displaywingname ? allWings.data[0].displaywingname : allWings.data[0].wingname);
          sessionStorage.setItem(
            "fastBookingSelectedWing",
            JSON.stringify(allWings.data[0].wingid)
          );
          sessionStorage.setItem(
            "fastBookingWingName",
            JSON.stringify(allWings.data[0].displaywingname ? allWings.data[0].displaywingname : allWings.data[0].wingname)
          );
          console.log(selectedLaunchId, false, allWings.data[0].wingid);
          getAllUnitsFun(selectedLaunchId, false, allWings.data[0].wingid);
        }
        setAllWings([...allWings.data]);
        sessionStorage.setItem(
          "fastBookingAllWings",
          JSON.stringify([...allWings.data])
        );
      })
      .catch((err) => {
        console.log(err);
      });
  }
  // ??Sustenance
  function getAllWings(projectId) {
    // getAllLaunchesByProject(projectId).then((launches) => {
    getAllWingsByProjectId(projectId)
      .then((res) => {
        console.log("ALL-WINGS", res);
        res.data = res.data.map((each) => ({
          ...each,
          label: each.wingId.displayName ? each.wingId.displayName : each.wingId.wingName,
          value: each.wingId.wingId,
          displayName: each?.wingId?.displayName ? each?.wingId?.displayName : each?.wingId?.wingName
        }));
        const wingSelectedData = sortBy(uniqBy([...res.data], 'wingId.wingName'), 'value')
        const projectSelectedAccess = JSON.parse(sessionStorage.getItem('fastBookingSelectedProjectData'));

        if (loggedInUser.roleId.level === 1) {
          setAllWings(sortBy(uniqBy([...res.data], 'wingId.wingName'), 'value'));
        sessionStorage.setItem(
          "fastBookingAllWings",
          JSON.stringify(
            sortBy(uniqBy([...res.data], "wingId.wingName"), "value")
          )
        );
        sessionStorage.setItem(
          "fastBookingWingName",
          JSON.stringify(res.data[0].displayName ? res.data[0].displayName : res.data[0].wingName)
        );
        setSelectedWingName(res.data[0].displayName ? res.data[0].displayName : res.data[0].wingName);
        setSelectedWing(res.data[0].value);

        sessionStorage.setItem(
          "fastBookingSelectedWing",
          JSON.stringify(res.data[0].value)
        );
        getAllUnits(
          projectId,
          res.data[0].value,
          selectedProjectData,
          search,
            'Sustenance'
          );
        } else {
          if (projectSelectedAccess.smAccess === "Wings") {
            getAllSalesByProjectWingsUser(projectId, SaleUserId.current).then((response) => {
              const filteredData = wingSelectedData.filter(item1 =>
                response.data.some(item2 => item1.wingId.wingId === item2.wingId)
              );
              setAllWings(filteredData);
              sessionStorage.setItem(
                'fastBookingAllWings',
                JSON.stringify(filteredData)
              );
              const wingNameSelected = filteredData[0].displayName
                ? filteredData[0].displayName
                : filteredData[0].wingName;
              sessionStorage.setItem(
                'fastBookingWingName',
                JSON.stringify(wingNameSelected)
              );

              setSelectedWingName(
                filteredData[0].displayName
                  ? filteredData[0].displayName
                  : filteredData[0].wingName
              );
              setSelectedWing(filteredData[0].value);

              sessionStorage.setItem(
                'fastBookingSelectedWing',
                JSON.stringify(filteredData[0].value)
              );
              getAllUnits(
                projectId,
                filteredData[0].value,
                selectedProjectData,
                search,
                'Sustenance'
              );
            })
              .catch((err) => {
                console.error('getAllSalesByProjectWingsUser', err);
              });
          } else if (projectSelectedAccess.smAccess === "Floors") {
            getAllSalesByProjectFloorsUser(projectId, SaleUserId.current).then((response) => {
              const filteredDataFloor = wingSelectedData.filter(item1 =>
                response.data.some(item2 => item1.wingId.wingId === item2.wingId)
              );

              setAllWings(filteredDataFloor);
              sessionStorage.setItem(
                'fastBookingAllWings',
                JSON.stringify(filteredDataFloor)
              );
              const wingNameSelected = filteredDataFloor[0].displayName
                ? filteredDataFloor[0].displayName
                : filteredDataFloor[0].wingName;
              sessionStorage.setItem(
                'fastBookingWingName',
                JSON.stringify(wingNameSelected)
              );

              setSelectedWingName(
                filteredDataFloor[0].displayName
                  ? filteredDataFloor[0].displayName
                  : filteredDataFloor[0].wingName
              );
              setSelectedWing(filteredDataFloor[0].value);

              sessionStorage.setItem(
                'fastBookingSelectedWing',
                JSON.stringify(filteredDataFloor[0].value)
              );
              getAllUnits(
                projectId,
                filteredDataFloor[0].value,
                selectedProjectData,
                search,
                'Sustenance'
              );


            })
              .catch((err) => {
                console.error('getAllSalesByProjectFloorsUser', err);
              });
          }
          else {
            setAllWings(sortBy(uniqBy([...res.data], 'wingId.wingName'), 'value'));
            sessionStorage.setItem(
              'fastBookingAllWings',
              JSON.stringify(
                sortBy(uniqBy([...res.data], 'wingId.wingName'), 'value')
              )
            );
            sessionStorage.setItem(
              'fastBookingWingName',
              JSON.stringify(
                res.data[0].displayName
                  ? res.data[0].displayName
                  : res.data[0].wingName
              )
            );
            setSelectedWingName(
              res.data[0].displayName
                ? res.data[0].displayName
                : res.data[0].wingName
            );
            setSelectedWing(res.data[0].value);

            sessionStorage.setItem(
              'fastBookingSelectedWing',
              JSON.stringify(res.data[0].value)
            );

            getAllUnits(
              projectId,
              res.data[0].value,
              selectedProjectData,
              search,
              'Sustenance'
            );
          }
        }



      })
      .catch((err) => {
        console.log(err);
      });
    // });
  }
  // ** To format totalBase Price
  function numDifferentiation(val) {
    if (val >= 10000000) val = (val / 10000000).toFixed(2) + " Cr";
    else if (val >= 100000) val = (val / 100000).toFixed(2) + " Lac";
    else if (val >= 1000) val = (val / 1000).toFixed(2) + " K";
    return val;
  }
  // ??Sustenance getAllUnits
  function getAllUnits(projectId, wingId, selectedProjectData, search, type) {
    // ??Sustenance check
    if (type === "Sustenance") {
      let projectInventoryTemp = [];
      let launchInventoryTemp = [];
      getSustenanceProjectInventory(projectId, wingId)
        .then((projectInventory) => {
          projectInventoryTemp = projectInventory.data.filter(
            ({ unitId }) => unitId !== null
          );
          // console.log({ projectInventoryTemp });
          getSustenanceLaunchInventory(projectId, wingId)
            .then((launchInventory) => {
              launchInventoryTemp = launchInventory.data.filter(
                ({ launchId, unitId }) => launchId !== null && unitId !== null
              );
              // console.log({ launchInventoryTemp });
              // ??For this project ,No Units are selected
              if (launchInventoryTemp.length === 0) {
                showProjectInventory(projectInventoryTemp);
              } else {
                checkingUnitsPresentInLaunch(
                  projectInventoryTemp,
                  launchInventoryTemp
                );
                // checkIfLaunchInventoryPresent(
                //   projectInventoryTemp,
                //   launchInventoryTemp
                // );
              }
            })
            .catch((err) => {
              console.log(err);
            });
        })
        .catch((err) => {
          console.log(err);
        });
    }
  }

  function checkingUnitsPresentInLaunch(
    projectInventoryTemp,
    launchInventoryTemp
  ) {
    sessionStorage.setItem(
      "fastBookingAllUnits",
      JSON.stringify(
        []
      )
    );
    let tempUnit = [];

    projectInventoryTemp.forEach((ele) => {
      let flag = false;
      var filteredArray = launchInventoryTemp.filter(function (obj) {
        return obj.unitId.unitId === ele.unitId.unitId;
      });
      filteredArray.forEach((em) => {
        if (em.launchId.eventId.endDateTime > Date.now()) {
          flag = true;
        }
      });
      if (!flag) {
        tempUnit.push(ele);
      }
    });

    // console.log('updated-tempUnit', tempUnit);
    showProjectInventory(tempUnit);
  }
  // function checkIfLaunchInventoryPresent(
  //   projectInventoryTemp,
  //   launchInventoryTemp
  // ) {
  //   sessionStorage.setItem(
  //     "fastBookingAllUnits",
  //     JSON.stringify(
  //     []
  //     )
  //   );
  //   let tempUnit = [];

  //  for(let i = 0; i < projectInventoryTemp.length;i++) {
  //   for(let j = 0; j < launchInventoryTemp.length; j++) {
  //     if(projectInventoryTemp[i].unitId.unitId !==
  //       launchInventoryTemp[j].unitId.unitId) {
  //         tempUnit.push(projectInventoryTemp[i])
  //       }
  //   }
  //  }

  //   for (let i = 0; i < projectInventoryTemp.length; i++) {
  //     for (let j = 0; j < launchInventoryTemp.length; j++) {
  //       if (
  //         projectInventoryTemp[i].unitId.unitId ===
  //         launchInventoryTemp[j].unitId.unitId
  //       ) {
  //         if (
  //           launchInventoryTemp[j].launchId.eventId.endDateTime < Date.now()
  //         ) {
  //           // console.log({ result });
  //           tempUnit.push(launchInventoryTemp[j]);
  //         }
  //       }
  //     }
  //   }

  //   console.log({ tempUnit });

  //   // ??To Check if this launch is present In live event
  //   let tempUnit2 = [];
  //   for (let i = 0; i < launchInventoryTemp.length; i++) {
  //     for (let j = 0; j < tempUnit.length; j++) {
  //       if (
  //         launchInventoryTemp[i].unitId.unitId === tempUnit[j].unitId.unitId
  //       ) {
  //         if (
  //           launchInventoryTemp[i].launchId.eventId.startDateTime <
  //             Date.now() &&
  //           launchInventoryTemp[i].launchId.eventId.endDateTime > Date.now()
  //         ) {
  //           return;
  //         } else {
  //           tempUnit2.push(tempUnit[j]);
  //         }
  //       }
  //     }
  //   }

  //   console.log(
  //     "BeforeUniqeBytempUnits",
  //     sortBy([...tempUnit2], "mergedUnits")
  //   );

  //   tempUnit2 = tempUnit2.map((each) => ({
  //     ...each,
  //     floorNo:
  //       each?.unitId.inventoryMergeId !== null
  //         ? each?.unitId.inventoryMergeId.unit1Id.floorNo +
  //           "-" +
  //           each?.unitId.inventoryMergeId?.unit2Id.floorNo
  //         : each.unitId.floorNo,
  //     mergedFloorNo:
  //       each?.unitId.inventoryMergeId !== null
  //         ? each?.unitId.inventoryMergeId.unit1Id.floorNo <
  //           each?.unitId.inventoryMergeId?.unit2Id.floorNo
  //           ? each?.unitId.inventoryMergeId.unit1Id.floorNo
  //           : each?.unitId.inventoryMergeId?.unit2Id.floorNo
  //         : each.unitId.floorNo,
  //     type:
  //       each?.unitId.inventoryMergeId !== null
  //         ? each?.unitId.inventoryMergeId.unit1Id.inventoryTypeId.type +
  //           "-" +
  //           each?.unitId.inventoryMergeId?.unit2Id.inventoryTypeId.type
  //         : each.unitId.inventoryTypeId.type,
  //     mergedUnits:
  //       each?.unitId.inventoryMergeId !== null
  //         ? each?.unitId.inventoryMergeId.unit1No.toString() +
  //           "-" +
  //           each.unitId.inventoryMergeId.unit2No.toString()
  //         : each?.unitId.unitNo.toString(),
  //     id: each.unitId.unitId,
  //     // projectPrice: projectPrice,
  //     showUnitPrice: selectedProjectData?.eventId?.showUnitPrice,
  //     showUnitDateTimePrice:
  //       selectedProjectData?.eventId?.showUnitPriceDateTime,
  //       displayUnitType: each?.unitId?.displayUnitType??""
  //   }));
  //   console.log(
  //     "tempUnits",
  //     sortBy(uniqBy([...tempUnit2], "mergedUnits"), "mergedUnits")
  //   );
  //   sessionStorage.setItem(
  //     "fastBookingAllUnits",
  //     JSON.stringify(
  //       uniqBy(
  //         sortBy(sortBy([...tempUnit2], "mergedUnits"), "mergedFloorNo"),
  //         "mergedUnits"
  //       )
  //     )
  //   );
  //   setAllUnit(
  //     uniqBy(
  //       sortBy(sortBy([...tempUnit2], "mergedUnits"), "mergedFloorNo"),
  //       "mergedUnits"
  //     )
  //   );
  // }
  function showProjectInventory(projectInventoryTemp) {
    let tempUnit2 = projectInventoryTemp.map((each) => ({
      ...each,
      floorNo:
        each?.unitId.inventoryMergeId !== null
          ? each?.unitId.inventoryMergeId.unit1Id.floorNo +
          "-" +
          each?.unitId.inventoryMergeId?.unit2Id.floorNo
          : each.unitId.floorNo,
      mergedFloorNo:
        each?.unitId.inventoryMergeId !== null
          ? each?.unitId.inventoryMergeId.unit1Id.floorNo <
            each?.unitId.inventoryMergeId?.unit2Id.floorNo
            ? each?.unitId.inventoryMergeId.unit1Id.floorNo
            : each?.unitId.inventoryMergeId?.unit2Id.floorNo
          : each.unitId.floorNo,
      type:
        each?.unitId.inventoryMergeId !== null
          ? each?.unitId.inventoryMergeId.unit1Id.inventoryTypeId.type +
          "-" +
          each?.unitId.inventoryMergeId?.unit2Id.inventoryTypeId.type
          : each.unitId.inventoryTypeId.type,
      displayUnitType: each?.unitId?.displayUnitType ?? "",
      mergedUnits:
        each?.unitId.inventoryMergeId !== null
          ? each?.unitId.inventoryMergeId.unit1No.toString() +
          "-" +
          each.unitId.inventoryMergeId.unit2No.toString()
          : each?.unitId.unitNo.toString(),
      id: each.unitId.unitId,
      // projectPrice: projectPrice,
      showUnitPrice: selectedProjectData?.eventId?.showUnitPrice,
      showUnitDateTimePrice:
        selectedProjectData?.eventId?.showUnitPriceDateTime,
    }));
    // console.log(
    //   'tempUnits',
    //   sortBy(uniqBy([...tempUnit2], 'mergedUnits'), 'mergedUnits')
    // );
    sessionStorage.setItem(
      "fastBookingAllUnits",
      JSON.stringify(
        uniqBy(
          sortBy(sortBy([...tempUnit2], "mergedUnits"), "mergedFloorNo"),
          "mergedUnits"
        )
      )
    );
    setAllUnit(
      uniqBy(
        sortBy(sortBy([...tempUnit2], "mergedUnits"), "mergedFloorNo"),
        "mergedUnits"
      )
    );
  }
  const debouncedFetchSearchData = debounce((e) => {
    // console.log('e: ', e);
    if (e.target.value !== "") {
      let result = JSON.parse(
        sessionStorage.getItem("fastBookingAllUnits")
      ).filter((each) => each.mergedUnits.includes(e.target.value));
      setAllUnit(result);
    } else {
      if (type === "Event") {
        getAllUnitsFun(
          JSON.parse(sessionStorage.getItem("fastBookingSelectedLaunch")),
          true,
          JSON.parse(sessionStorage.getItem("fastBookingSelectedWing")) ?? ""
        );
      } else {
        let projectId =
          JSON.parse(sessionStorage.getItem("fastBookingSelectedProject")) ??
          "";
        setSelectedProject(projectId);
        let wingId =
          JSON.parse(sessionStorage.getItem("fastBookingWing")) ?? "";
        if (projectId !== "" && wingId !== "") {
          getAllUnits(
            projectId,
            wingId,
            selectedProjectData,
            null,
            "Sustenance"
          );
        }
      }
    }

    //   selectedProject,
    //   selectedWing,
    //   selectedProjectName,
    //   e.target.value,
    //   type
    // );
  }, 800);

  // ** type===event ,eventConfig DateTime check
  function checkEndDate(showUnitDateTimePrice) {
    if (type === "Event") {
      return new Date(showUnitDateTimePrice) > Date.now();
    } else {
      return true;
    }
  }
  return (
    <div className={cssClasses.wrapperPage}>
      <div className="pageTitleWrapper">
        <div className="title">Fast Booking</div>
      </div>
      <div className={cssClasses.wrapperPage}>
        <div className={cssClasses.bookingsWrap}>
          <div className={cssClasses.allDropdown}>
            <div className={cssClasses.dropdownWrap}>
              <div className={cssClasses.blockLabel}>
                Select Type <span style={{ color: "red" }}> *</span>
              </div>
              <div style={{ width: "25rem" }}>
                <DropDown
                  list={["Event", "Sustenance"]}
                  selectedValue={type}
                  onChangeSelect={(value) => {
                    clearData();
                    setType(value);
                    sessionStorage.setItem(
                      "fastBookingType",
                      JSON.stringify(value)
                    );

                    if (value === "Sustenance") {
                      sessionStorage.setItem(
                        "isEventLive",
                        JSON.stringify(false)
                      );
                      getProject();
                    } else {
                      getAllEventsFun();
                      sessionStorage.setItem(
                        "isEventLive",
                        JSON.stringify(true)
                      );
                    }
                  }}
                  placeHolder={"Select"}
                  //style.color is placeHolder's color
                  style={{
                    background: "#F2F4F7",
                    color: "rgb(102, 112, 133)",
                  }}
                />
              </div>
            </div>
            {type === "Event" && (
              <>
                <div className={cssClasses.dropdownWrap}>
                  <div className={cssClasses.blockLabel}>
                    Select Event <span style={{ color: "red" }}> *</span>
                  </div>
                  <div style={{ width: "25rem" }}>
                    <DropDown
                      list={eventList}
                      selectedValue={selectedEvent}
                      onChangeSelect={(value) => {
                        sessionStorage.setItem(
                          "fastBookingEvent",
                          JSON.stringify(value)
                        );
                        setAllUnit([]);
                        setSelectedUnit("");
                        setSelectedWing("");
                        setAllWings([]);
                        setAllLaunches([]);
                        setSelectedEvent(value);
                        setSelectedLaunch("");
                        getAllLaunches(value);
                        // getTokenDetails(selectedEvent[0].eventId);
                      }}
                      placeHolder={"Select"}
                      //style.color is placeHolder's color
                      style={{
                        background: "#F2F4F7",
                        color: "rgb(102, 112, 133)",
                      }}
                    />
                  </div>
                </div>
                <div className={cssClasses.dropdownWrap}>
                  <div className={cssClasses.blockLabel}>
                    Select Launches <span style={{ color: "red" }}> *</span>
                  </div>
                  <div style={{ width: "25rem" }}>
                    <DropDown
                      // list={uniqBy(allProjects, 'label')}
                      list={allLaunches}
                      // label="Projects*"
                      selectedValue={selectedLaunch}
                      onChangeSelect={(_value) => {
                        sessionStorage.setItem(
                          "fastBookingSelectedLaunch",
                          JSON.stringify(_value)
                        );

                        // console.log(_value);
                        setSelectedLaunch(_value);
                        getWingsByLaunchId(_value);
                        setAllUnit([]);
                        setSelectedWing("");
                        setShowSearchResult(false);

                        let selectedLaunch = allLaunches.filter(
                          ({ launchId }) => launchId === _value
                        );
                        // console.log({ selectedLaunch });
                        setSelectedProject(
                          selectedLaunch[0].projectId.projectId
                        );
                        setSelectedProjectData(selectedLaunch[0].projectId);
                        sessionStorage.setItem(
                          "fastBookingSelectedProject",
                          JSON.stringify(selectedLaunch[0].projectId.projectId)
                        );
                      }}
                      helperText=""
                      style={{
                        background: "#F2F4F7",
                        color: "rgb(102, 112, 133)",
                      }}
                      placeHolder="Select Launch"
                    ></DropDown>
                  </div>
                </div>
              </>
            )}

            {type === "Sustenance" && (
              <div className={cssClasses.dropdownWrap}>
                <div className={cssClasses.blockLabel}>
                  Select Project <span style={{ color: "red" }}> *</span>
                </div>
                <div style={{ width: "25rem" }}>
                  <DropDown
                    // list={uniqBy(allProjects, 'label')}
                    list={allProjects}
                    // label="Projects*"
                    selectedValue={selectedProject}
                    onChangeSelect={(_value) => {
                      sessionStorage.setItem(
                        "fastBookingSelectedProject",
                        JSON.stringify(_value)
                      );

                      // console.log(_value);
                      setSelectedProject(_value);
                      allProjects.forEach((el, index) => {
                        if (el.value === _value) {
                          setAllProjects((pre) => {
                            setSelectedProjectName(pre[index].label);
                            pre[index].isSelected = true;
                            return [...pre];
                          });
                          getAllWings(_value);
                          setAllUnit([]);

                          setShowSearchResult(false);
                        } else {
                          setAllProjects((pre) => {
                            pre[index].isSelected = false;
                            return [...pre];
                          });
                        }
                      });
                      let selectedProject = allProjects.filter(
                        ({ value }) => value === _value
                      );
                      // console.log("selectedProject", selectedProject[0]);
                      setSelectedProjectData(selectedProject[0]);
                      sessionStorage.setItem(
                        "fastBookingSelectedProjectData",
                        JSON.stringify(selectedProject[0])
                      );
                    }}
                    helperText=""
                    style={{
                      background: "#F2F4F7",
                      color: "rgb(102, 112, 133)",
                    }}
                    placeHolder="Select Project"
                  ></DropDown>
                </div>
              </div>
            )}
            {type !== "" && (
              <div className={cssClasses.dropdownWrap}>
                <div className={cssClasses.blockLabel}>
                  Select Wing <span style={{ color: "red" }}> *</span>
                </div>
                <div style={{ width: "25rem" }}>
                  <DropDown
                    list={sortBy(allWings, "wingName")}
                    selectedValue={selectedWing}
                    // disable={selectedProject !== "" ? false : true}
                    onChangeSelect={(_value) => {
                      if (selectedWing !== '') {
                        document.getElementById(
                          "input-with-icon-textfield UnitSearch"
                        ).value = "";
                      }
                      sessionStorage.setItem(
                        "fastBookingWing",
                        JSON.stringify(_value)
                      );
                      setSelectedWing(_value);
                      if (type === "Event") {
                        let selectedWingName = allWings.filter(
                          ({ wingId }) => wingId === _value
                        );
                        console.log({ selectedWingName });
                        setSelectedWing(selectedWingName[0].wingId);
                        setSelectedWingName(selectedWingName[0].displaywingname ? selectedWingName[0].displaywingname : selectedWingName[0].wingName);
                        getAllUnitsFun(selectedLaunch, false, _value);
                        sessionStorage.setItem(
                          "fastBookingSelectedWing",
                          JSON.stringify(selectedWingName[0].wingId)
                        );
                        sessionStorage.setItem(
                          "fastBookingWingName",
                          JSON.stringify(selectedWingName[0].displaywingname ? selectedWingName[0].displaywingname : selectedWingName[0].wingName)
                        );
                      } else {
                        setAllUnit([]);
                        getAllUnits(
                          selectedProject,
                          _value,
                          selectedProjectData,
                          null,
                          type
                        );
                        let selectedWingName = allWings.filter(
                          ({ value }) => value === _value
                        );
                        setSelectedWing(selectedWingName[0].value);
                        setSelectedWingName(selectedWingName[0].displaywingname ? selectedWingName[0].displaywingname : selectedWingName[0].wingName);
                        sessionStorage.setItem(
                          "fastBookingWingName",
                          JSON.stringify(selectedWingName[0].displaywingname ? selectedWingName[0].displaywingname : selectedWingName[0].wingName)
                        );
                        sessionStorage.setItem(
                          "fastBookingSelectedWing",
                          JSON.stringify(selectedWingName[0].value)
                        );
                        setShowSearchResult(false);
                      }
                      if (allUnits.length > 0) {
                        document.getElementById(
                          "input-with-icon-textfield UnitSearch"
                        ).value = "";
                      }
                    }}
                    helperText=""
                    style={{
                      background: "#F2F4F7",
                      color: "rgb(102, 112, 133)",
                    }}
                    placeHolder="Select Wing"
                  ></DropDown>
                </div>
              </div>
            )}
          </div>
          {selectedWing !== "" && (
            <div className={cssClasses.wrapperInventory}>
              <span className={cssClasses.InventoryTitle}>Inventory</span>
              <div className={cssClasses.wrapperSearchBar}>
                <SearchBar
                  id={"UnitSearch"}
                  placeholder={"Search by unit"}
                  search={debouncedFetchSearchData}
                  width="100%"
                />
              </div>
            </div>
          )}

          <div className={cssClasses.allUnitsWrap}>
            {/* // ! floors may not be sorted as it was added before making floor as string */}
            {sortBy(allUnits, (fl) => {
              return isNaN(parseInt(fl.mergedFloorNo.split(" ")[1]))
                ? 0
                : parseInt(fl.mergedFloorNo.split(" ")[1]);
            }).map((each, index) => (
              // <div className={cssClasses.eventCardWrap}>
              <Card
                sx={{
                  padding: window.innerWidth <= 820 ? "1rem" : "2rem",
                  width:
                    window.innerWidth <= 820
                      ? "calc(99% - 2rem)"
                      : "calc(100% - 4rem)",

                  // color: "#344054",
                  fontSize: "1.6rem",
                  fontFamily: "Inter-Regular",
                  lineHeight: "2.4rem",

                  display: "flex",
                  flexDirection: "row",
                  flexWrap: "wrap",
                  // justifyContent: "space-between",
                  alignItems: "center",
                  boxShadow:
                    "0px 1px 3px rgb(16 24 40 / 10%), 0px 1px 2px rgb(16 24 40 / 6%) !important",
                  borderRadius: "0.8rem !important",
                  border: " 1px solid rgba(0, 0, 0, 0.12) !important",
                  gap: "1rem",
                }}
              >
                <div className={cssClasses.wrapperInfo}>
                  <div className={cssClasses.cardunitDetails}>
                    <span className={cssClasses.unit}>
                      {selectedWingName}-{each?.mergedUnits}
                    </span>{" "}
                    | {each?.floorNo}
                    {selectedProjectData?.displayInventoryType?.includes(
                      "Inventory Type"
                    )
                      ? "|" + each?.type
                      : ""}
                    {each?.displayUnitType !== '' && selectedProjectData?.displayInventoryType !== null && selectedProjectData?.displayInventoryType?.includes(
                      "Display Unit Type"
                    )
                      ? "|" + each?.displayUnitType
                      : ""}
                    {/* | Floor {each?.floorNo}| {each?.type} */}
                  </div>
                  {each?.showUnitPrice &&
                    checkEndDate(each?.showUnitDateTimePrice) && (
                      <div className={cssClasses.cardProjectName}>
                        {each?.projectPrice ? (
                          <span className={cssClasses.cardVal}>
                            ₹{each?.projectPrice}
                          </span>
                        ) : (
                          ""
                        )}
                      </div>
                    )}
                  <div className={cssClasses.wrapperButton}>
                    <Button
                      style={{
                        color: "#FFFFFF",
                        backgroundColor: "#155EEF",
                        fontSize: "1.6rem",
                        lineHeight: "2.4rem",
                      }}
                      btnName={"Book Now"}
                      // disable={!showSearchResult}
                      clicked={() => {
                        if (type === "Event") {
                          let selectetProject = searchResult.filter(
                            ({ isSelected }) => isSelected === true
                          );
                          // console.log(selectedProject);
                          sessionStorage.setItem(
                            "fastBookingSelectedUnit",
                            JSON.stringify(each.unitId.unitId)
                          );
                          // console.log(
                          //   `/home/Event/Details/${selectedEvent}/DirectAllotment/${selectedLaunch}/${selectedProject}/${selectedWing}/${each.unitId.unitId}`
                          // );
                          navigate(
                            `/home/Event/Details/${selectedEvent}/DirectAllotment/${selectedLaunch}/${selectedProject}/${selectedWing}/${each.unitId.unitId}`
                          );
                        } else if (type === "Sustenance") {
                          console.log(selectedUnitId);
                          navigate(
                            `/home/Sustenance/Details/${selectedProject}/DirectAllotment/${selectedWing}/${each.unitId.unitId}`
                          );
                        }
                      }}
                    />
                  </div>
                </div>
              </Card>
              // </div>
            ))}
            {allUnits.length === 0 && selectedWingName !== "" && (
              <div className={cssClasses.wrapperMessage}>
                <div className={cssClasses.containsMessage}>
                  <div className={cssClasses.messageFutureUnits}>
                    No units available
                  </div>
                  {/* <div className={cssClasses.subFutureUnits}>
                    Allotment for this unit is not Available for now
                  </div> */}
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default FastBooking;
